import { Box, Typography, Button, Icon, useMediaQuery, useTheme } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

export const BANNER_HEIGHT = 40;
export const BANNER_HEIGHT_MOBILE = 56;

interface ImpersonationBannerProps {
  empresaRazon?: string;
}

export default function ImpersonationBanner({ empresaRazon }: ImpersonationBannerProps) {
  const { impersonatingEmpresaId, stopImpersonation } = useAuth();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  if (!impersonatingEmpresaId) return null;

  const height = isSmall ? BANNER_HEIGHT_MOBILE : BANNER_HEIGHT;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar + 2,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        minHeight: height,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 0.5, sm: 2 },
        px: 2,
        py: { xs: 0.5, sm: 0 },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <Icon sx={{ fontSize: 18 }}>visibility</Icon>
        <Typography
          variant="body2"
          fontWeight={600}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Estas viendo como: {empresaRazon ?? `Empresa ${impersonatingEmpresaId.slice(0, 8)}...`}
        </Typography>
      </Box>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ArrowBack />}
        sx={{
          color: 'inherit',
          borderColor: 'currentColor',
          py: 0,
          '&:hover': { borderColor: 'currentColor', bgcolor: 'rgba(255,255,255,0.1)' },
        }}
        onClick={stopImpersonation}
      >
        Volver a Admin
      </Button>
    </Box>
  );
}
